import React from 'react';
import { useState, useEffect } from 'react';
import "./product-development.scss";
import meta_tags from '../../Data/MetaTags';
import {
  useLocation,
} from 'react-router-dom';
import LendingLabData from './LendingLabData';
import ProductBanner from '../Products/ProductBanner';
import ProductIntro from '../Products/ProductIntro';
import ProductFeatures from '../Products/ProductFeatures';
import ProductFooterCtaSection from '../Products/ProductFooterCtaSection';
import ProductBenifits from '../Products/ProductBenifits';



function LendingLab() {

  const [rendercount, setRenderCount] = useState(() => false);

  const location = useLocation();
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    setRenderCount(true)
    if (rendercount === true) {
     
      document.title = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].title : '';
      
      document.getElementById('meta-tags').content = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].content : '';
      document.getElementById('canonical-link').href = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].link : '';
      
      if(!(document.getElementById('link1')==null)){
        document.getElementById('link1').remove();
      document.getElementById('link2').remove();
      document.getElementById('link3').remove();
      document.getElementById('link4').remove();
      document.getElementById('link5').remove();
      document.getElementById('link6').remove();
      
      }
    }
  }, [rendercount])
  
  return (
    <div>

        <ProductBanner data={LendingLabData.BannerData} openModal={openModal}/>
        <ProductIntro data={LendingLabData.Introduction}/>
        <ProductFeatures data={LendingLabData.Features} />
        <ProductBenifits data={LendingLabData.ProductBenifits} />
        <ProductFooterCtaSection data={LendingLabData.FooterCtaSection} openModal={openModal}/>
    </div>
  )
}

export default LendingLab;
